import { format } from 'date-fns-tz';
import isEmpty from 'lodash/isEmpty';
import moment from 'moment';
import { currencyToSymbolMap } from '../../../utils/currency';

export const _getNearestTimeByFactor = (date = new Date(), minuteFactor) => {
    const nearestStartMinutes =
        (Math.floor(moment(date).get('minute') / minuteFactor) + 1) *
        minuteFactor;
    return moment(date).set({
        minute: nearestStartMinutes,
        second: 0,
    });
};

export const getNearestQuarter = (date) => _getNearestTimeByFactor(date, 15);

export const toDateStr = (date) => format(date, 'yyyy-MM-dd');
export const toTimeStr = (date) => format(date, 'HH:mm');

/**
 * Utility function to adjust native date as per the timezone offset
 * @param {Date} date Date to be adjusted
 * @param {string} offset offset of the timezone as per which native date has to be adjusted
 */
export const adjustDateByTimeZone = (date, offset, keepSecs = false) => {
    const format = `YYYY-MM-DD HH:mm${keepSecs ? ':ss' : ''}`;
    const localDateStr = moment(date).format(format);
    const adjustedTzTime = moment(
        `${localDateStr} ${offset}`,
        `${format} Z ZZ`
    );
    return adjustedTzTime.toDate();
};

export const getCurrencyList = () => {
    const currencyObj = currencyToSymbolMap();

    let currencyList = Object.keys(currencyObj).map((currencyKey) => {
        return {
            value: currencyKey,
            label: `${currencyKey}`,
        };
    });

    return currencyList;
};

export const getCurrency = (currency) => {
    if (Object.prototype.toString.call(currency) === '[object Object]') {
        return (currency && currency.value) || currency;
    } else {
        return currency;
    }
};
/**
 * Utility function to get formatted time (default format: "HH:MM AM/PM")
 * @param {Date String} time
 */
export const getFormattedTime = ({ time, timeLocale, timeOptions }) => {
    if (!time) {
        return null;
    }

    const locale = timeLocale ? timeLocale : [];
    const option = timeOptions
        ? timeOptions
        : {
              hour: '2-digit',
              minute: '2-digit',
              hourCycle: 'h12',
          };

    return new Date(time).toLocaleTimeString(locale, option).toUpperCase();
};

export const getFirstName = (name) => {
    let firstName = name.split(' ').slice(0, 1).join(' ');
    return firstName;
};

export const getLastName = (name) => {
    let lastName = name.split(' ');
    lastName.splice(0, 1);
    return lastName.slice(-1).join(' ');
};

export const getFullName = (user) => {
    if (user?.name) {
        return user.name;
    } else if (user?.firstName) {
        return `${user.firstName} ${user.lastName}`;
    }
    return '';
};

export const splitName = (user) => {
    if (!user?.firstName) {
        const nameArr = user?.name.split(' ');
        const firstName =
            nameArr.length === 1
                ? nameArr[0]
                : user?.name.split(' ').slice(0, -1).join(' ');
        const lastName =
            nameArr.length === 1
                ? ''
                : user?.name.split(' ').slice(-1).join(' ');
        return { firstName, lastName };
    }
    return { firstName: user.firstName, lastName: user.lastName };
};

export const getDefaultCommunity = (communityData, communityId = null) => {
    const { cm, em } = communityData;
    let defaultCommunity;

    if (communityId) {
        const cmCommunityObj = (cm || []).find(
            (obj) => obj.communityId === communityId
        );
        if (!isEmpty(cmCommunityObj)) return cmCommunityObj;
        const emCommunityObj = (em || []).find(
            (obj) => obj.communityId === communityId
        );
        if (!isEmpty(emCommunityObj)) return emCommunityObj;
    }
    if (cm && cm.length > 0) {
        defaultCommunity = cm[0];
    } else if (em && em.length > 0) {
        defaultCommunity = em[0];
    }
    return defaultCommunity;
};

export const getThemeAgnosticAmbience = (colorIdx, theme) => {
    const {
        isLightTheme,
        colors: { ambience },
    } = theme;
    if (!isLightTheme) {
        return colorIdx;
    }
    return ambience.length - 1 - colorIdx;
};

export const getAmbienceColorId = ({ colorId, isAgnostic, theme }) => {
    return isAgnostic ? getThemeAgnosticAmbience(colorId, theme) : colorId;
};

export const textEllipsis = (
    str = '',
    maxLength,
    { ellipsis = '...' } = {}
) => {
    if (str.length > maxLength) {
        return str.slice(0, maxLength - ellipsis.length) + ellipsis;
    }
    return str;
};
